module.exports = {
  HOME: "/home",
  SHOW: (id) => `/show/${id}`,
  SHOW_CREATE: "/show/create",
  SHOW_CONSOLE: (id) => `/show/${id}/console`,
  CALLBACK_FACEBOOK: "/cb/facebook",
  CALLBACK_GOOGLE: "/cb/google",
};
